import React, { useEffect, useState }  from 'react';
import Popup from "reactjs-popup";
import Typography from '@mui/material/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {status_filter, project_list, group_list, experiments_view} from '../../../service/apis';
import FilterCriteria from './components/FilterCriteria';
import SmallTableViews from './components/SmallTableViews';
import {GPAP_Button_light, GPAP_Button_Orange} from "../../../../gpap-lib/Button_Collection";

import { ReactTableServerSide } from '../../ReactTableServerSide';
import { CsvButton } from '../../../service/CsvButton';

import { downloadCSV } from '../../../service/CsvButton';
import auth from '../../../service/Auth';
import "./experimentDates.css"
import settings from '../../../DataManagementConfig';



const config = window.config;

const ExperimentsDates = () => {

    const [csvFileName, setCsvFileName] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [libraryStrategy, setLibraryStrategy] = useState({ title : "Library Strategy",  value:"all", selection : []});
    const [project, setProject] = useState({ title : "Project",  value:"all", selection : []});
    const [group, setGroup] = useState({ title : "Group",  value:"all", selection : []});
    const [status, setStatus] = useState({ title : "Experiment Status",  
                                           value:"in_platform",
                                           selection : ["rawDownload","receptionPipeline","mapping","variantCalling","coverage","rohs","in_platform"]
                                        });
    const [statusContents, setStatusContents] = useState({
        experiments: [],
        aggregates: {},
        pagination : {
            page : 1,
            pages : 1,
            pageSize : 1,
            totalItems : 1,
            fields :1,
            loadData : true
        },
        urlQuery: {
            page: 1, 
            pageSize: settings.basicPageSize,
            fields: ["RD_Connect_ID_Experiment","in_platform"],
            filtered: [
                {"id":"FromDate","value":""},
                {"id":"ToDate","value":""},
                {"id":"in_platform","value":"pass"}
            ],
            aggregates: ["Owner"]
        }
    });                                                                              
    const [message, setMessage] = useState("");


    const fetchProjectList = async () => {
        // Get Project Lists
        let projects = ['all'];
        await project_list(auth.getToken(),config.api_endpoint)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            const projectList = data.map(item => { return item.project_title });
            projects.push(...projectList);
            project.selection = projects;
            setProject({...project});
        });
    } 

    const fetchGroupList = async () => {
        // Get Group Lists
        let groups = ['all'];
        await group_list(auth.getToken(),config.api_endpoint)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            const groupList = data.map(item => { return item.name });
            groups.push(...groupList);
            group.selection = groups;
            setGroup({...group});
        });
    } 

    const fetchLibraryStrategyList = async () => {
        // Get Library Strategy Lists
        const bodyFetch = {"page":1, "pageSize":1, "fields":["ExperimentID","library_strategy"],
                           "filtered":[], "sorted":[],
                           "aggregates": ["library_strategy"]};
        await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyFetch))
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            libraryStrategy.selection = Object.keys(data._meta.aggregates.library_strategy[0]);
            libraryStrategy.selection = ['all', ...libraryStrategy.selection];
            setLibraryStrategy({...libraryStrategy});
        });
    }

    useEffect(() => {
        // 1.Logging Check 
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else if (!auth.isUserAdmin()) {
            setErrors("User does not have admin permissions.");
        }
        else {
            // 2. Fetch Project and Group Lists
            fetchProjectList();
            fetchGroupList();
            fetchLibraryStrategyList();
        } 
    }, [])

    const handleStartDate = (date) => {
        setStartDate(date);
        setEndDate(null);
    };

    const handleEndDate = (date) => {
        setEndDate(date);
    };

    const changeSelection = event => {
        event.preventDefault();
        const name = event.target.name;
        const value = event.target.value;
        //Update according to select name
        switch (name) {
                case "libraryStrategy":
                    libraryStrategy.value = value;
                    setLibraryStrategy({...libraryStrategy});
                    break;
                case "project":
                    project.value = value;
                    setProject({...project});
                    break;    
                case "group":
                    group.value = value;
                    setGroup({...group});
                    break;
                case "status":
                    status.value = value
                    setStatus({...status});
                    break;
        }
    }

    const filter = event => {
        event.preventDefault();
        //1. Set Filters
        if ( startDate === null || endDate === null) {
            setMessage("Start Date and End Date can not be empty to perform the query.");
            return;
        }
        let filtered = [
            {"id":"FromDate",
             "value": dateFormat(startDate)},
            {"id":"ToDate",
             "value": dateFormat(endDate)}
        ];
        //1.1. Check Experiment type
        if ( libraryStrategy.value !== "all") {
            filtered.push({"id":"library_strategy","value":libraryStrategy.value});
        }
        //1.2. Project
        if ( project.value !== "all") {
            filtered.push({"id":"project","value":project.value});
        }
        //1.3. Group
        if ( group.value !== "all") {
            filtered.push({"id":"Owner","value":group.value});
        }
        //1.4. Status
        if ( status.value !== "all") {
            filtered.push({"id":status.value,"value":"pass"});
        }
        //2. Experiment Fields
        let fields = ["RD_Connect_ID_Experiment","Owner","project","library_strategy"];
        //2.1. Status Field
        fields.push(status.value);
        fields.push(status.value + "Time");
        //3. Aggregates Fields
        let agregates = ["Owner","project","library_strategy"];
        //4. Body Query
        statusContents.urlQuery.fields = fields;
        statusContents.urlQuery.filtered = filtered;
        statusContents.urlQuery.aggregates = agregates;
        //5. Call API
        status_filter(auth.getToken(), config.api_endpoint, JSON.stringify(statusContents.urlQuery))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            statusContents.experiments = data["items"];
            statusContents.aggregates = data["_meta"]["aggregates"];
            statusContents.pagination.page = data["_meta"]["page"];
            statusContents.pagination.pages = data["_meta"]["total_pages"];
            statusContents.pagination.pageSize = data["_meta"]["page_size"];
            statusContents.pagination.totalItems = data["_meta"]["total_items"];
            statusContents.pagination.fields = fields;
            statusContents.pagination.loadData = false;
            statusContents.urlQuery = {...statusContents.urlQuery};
            setStatusContents({...statusContents});            
        })
    }

    const getOwnerTable = () => {
        //Translates API Data result to data and columns for react-table
        let columns = [];
        //0. Define Header Labels
        let headers = [ { label: 'Owner', key: 'Owner'}, { label: 'Experiments', key: 'experiments'} ]
        //1. Add Header Titles
        //1.1 Experiment Owner
        columns.push({ Header: "Owner", accessor: "Owner", minWidth: 200, filterable:false, sortable:false});
        //1.2 Total Experiments
        columns.push({ Header: "Experiments", accessor: "experiments", minWidth: 50, filterable:false, sortable:false});
        //2. Build data to render on react-table
        let data = [];
        if (statusContents.aggregates !== undefined)
        {
            if ("Owner" in statusContents.aggregates) {
                const owners = statusContents.aggregates.Owner[0];
                for (const owner in owners) {
                    data.push({"Owner":owner, "experiments": owners[owner]});
                }
            }
        }
        //3. Table Pagination
        let pagination = { pageSize: data.length, page: 1, pages: 1, totalItems: statusContents.pagination.totalItems };
        return { headers: headers, columns:columns, data: data, pagination: pagination};
    }

    const getProjectTable = () => {
        //Translates API Data result to data and columns for react-table
        let columns = [];
        //0. Define Header Labels
        let headers = [ { label: 'Project', key: 'project'}, { label: 'Experiments', key: 'experiments'} ]
        //1. Add Header Titles
        //1.1 Experiment Owner
        columns.push({ Header: "Project", accessor: "project", minWidth: 200, filterable:false, sortable:false});
        //1.2 Total Experiments
        columns.push({ Header: "Experiments", accessor: "experiments", minWidth: 50, filterable:false, sortable:false});
        //2. Build data to render on react-table
        let data = [];
        if (statusContents.aggregates !== undefined)
        {
            if ("project" in statusContents.aggregates) {
                const projects = statusContents.aggregates.project[0];
                for (const project in projects) {
                    data.push({"project":project, "experiments": projects[project]});
                }
            }
        }
        //3. Table Pagination
        let pagination = { pageSize: data.length, page: 1, pages: 1, totalItems: statusContents.pagination.totalItems };
        return { headers: headers, columns:columns, data: data, pagination: pagination};
    }

    const getLibraryStrategyTable = () => {
        //Translates API Data result to data and columns for react-table
        let columns = [];
        //0. Define Header Labels
        let headers = [ { label: 'Library Strategy', key: 'library_strategy'}, { label: 'Experiments', key: 'experiments'} ]
        //1. Add Header Titles
        //1.1 Experiment Owner
        columns.push({ Header: "Library Strategy", accessor: "library_strategy", minWidth: 200, filterable:false, sortable:false});
        //1.2 Total Experiments
        columns.push({ Header: "Experiments", accessor: "experiments", minWidth: 50, filterable:false, sortable:false});
        //2. Build data to render on react-table
        let data = [];
        if (statusContents.aggregates !== undefined)
        {
            if ("library_strategy" in statusContents.aggregates) {
                const strategies = statusContents.aggregates.library_strategy[0];
                for (const strategy in strategies) {
                    data.push({"library_strategy":strategy, "experiments": strategies[strategy]});
                }
            }
        }
        //3. Table Pagination
        let pagination = { pageSize: data.length, page: 1, pages: 1, totalItems: statusContents.pagination.totalItems };
        return { headers: headers, columns:columns, data: data, pagination: pagination};
    }

    const getExperimentItemsTable = () => {
        //Translates API Data result to data and columns for react-table
        let columns = [];
        //0. Define Header Labels
        let headers = [ { label: 'ExperimentID', key: 'RD_Connect_ID_Experiment'}, { label: 'Owner', key: 'Owner'},
                        { label: 'Project', key: 'project'}, { label: 'LibraryStrategy', key: 'library_strategy'},
                        { label: status.value, key: status.value},
                        { label: status.value + "Time", key: status.value + "Time"}
        ]
        //1. Add Header Titles
        columns.push({ Header: "ExperimentID", accessor: "RD_Connect_ID_Experiment", minWidth: 100});
        columns.push({ Header: "Owner", accessor: "Owner", minWidth: 100});
        columns.push({ Header: "Project", accessor: "project", minWidth: 100});
        columns.push({ Header: "LibraryStrategy", accessor: "library_strategy", minWidth: 50});
        columns.push({ Header: status.value + "Time", accessor: status.value + "Time", minWidth: 75, filterable:false });
        //2. Build data to render on react-table
        let data = [];
        if (statusContents.experiments !== undefined)
        {
            for (let experimentObject of statusContents.experiments) {
                let row = {};
                row["RD_Connect_ID_Experiment"] = experimentObject.RD_Connect_ID_Experiment;
                row["Owner"] = experimentObject.Owner;
                row["project"] = experimentObject.project;
                row["library_strategy"] = experimentObject.library_strategy;
                row[status.value] = experimentObject[status.value];
                row[status.value + "Time"] = experimentObject[status.value + "Time"];
                data.push(row);
            }
        }
        //3. Table Pagination
        return { headers: headers, columns:columns, data: data, pagination: statusContents.pagination};
    }

    const dateFormat = (date) => {
        return date.getFullYear().toString() + "-" + (date.getMonth() + 1).toString() + "-" + date.getDate().toString();
    }

    const getCsvOwnerData = async (event) => {
        const stDate = dateFormat(startDate);
        const lastDate = dateFormat(endDate);
        const columnsDataOwner = getOwnerTable();
        const headersCsv = [{label:"Owner", key:"Owner"},{label:"Experiments", key:"experiments"}];
        downloadCSV(columnsDataOwner.data,headersCsv,stDate + "_to_" + lastDate + "_group_list.csv");
    }

    const getCsvProjectData = async (event) => {
        const stDate = dateFormat(startDate);
        const lastDate = dateFormat(endDate);
        const columnsDataProject = getProjectTable();
        const headersCsv = [{label:"Project", key:"project"},{label:"Experiments", key:"experiments"}];
        downloadCSV(columnsDataProject.data,headersCsv,stDate + "_to_" + lastDate + "_project_list.csv");
    }

    const getCsvStrategyData = async (event) => {
        const stDate = dateFormat(startDate);
        const lastDate = dateFormat(endDate);
        const columnsDataLibraryStrategy = getLibraryStrategyTable();
        const headersCsv = [{label:"Library Strategy", key:"library_strategy"},{label:"Experiments", key:"experiments"}]
        downloadCSV(columnsDataLibraryStrategy.data,headersCsv,stDate + "_to_" + lastDate + "_strategy_list.csv");
    }

    const getCsvExperimentsData = async (event) => {
        // 0.Trigger Load Process
        statusContents.pagination.loadData = true;
        setStatusContents({...statusContents});
        // 1. Get Body Data Query
        let csvExperimentsData = {data:[]};
        // 2. Loop To Retrieve all values
        let getData = true;
        statusContents.urlQuery.page = 1;
        statusContents.urlQuery.pageSize = settings.apiExperimentCSVPageSize;
        while (getData){
            // 2.1 Call POST Data
            await status_filter(auth.getToken(), config.api_endpoint, JSON.stringify(statusContents.urlQuery))
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                csvExperimentsData.headers = Object.keys(data["items"][0]).map(field => { return {label:field, key: field} });
                csvExperimentsData.data.push(...data["items"]);
                if (statusContents.urlQuery.page < data["_meta"]["total_pages"]){
                    getData = true;
                    statusContents.urlQuery.page = statusContents.urlQuery.page + 1;
                }
                else getData = false;
            })
        }
        // 3. Build name and update state
        let stDate = dateFormat(startDate);
        let lastDate = dateFormat(endDate);
        downloadCSV(csvExperimentsData.data,csvExperimentsData.headers,stDate + "_to_" + lastDate + "_experiments_detail.csv");
        statusContents.pagination.loadData = false;
        setStatusContents({...statusContents});
    }

    // On Row Click 
    const onRowClick = (state,instance) => {}

    // Empty Method Defined for Debounce React Table Server Side 
    const loadTableData = (state,instance) => {}

    // Method to call API Endpoint to get React Table Data
    const loadExperimentsTableData = (state,instance) => {
        // 0. Check if dates are defined
        if ( startDate !== "" ||  endDate !== "") return;
        // 1. Update pagination Update
        statusContents.pagination.loadData = true;
        setStatusContents({...statusContents});
        // 2. Setup Query
        statusContents.urlQuery.page = (state.page + 1);
        statusContents.urlQuery.pageSize = state.pageSize;
        // 3. Check filtered Criteria
        if (state.filtered.length > 0) {
            for (let filterCriteria of state.filtered) {
                let filterIndex = statusContents.urlQuery.filtered.findIndex(item => item.id === filterCriteria.id);
                if (filterIndex === -1){
                    statusContents.urlQuery.filtered.push(filterCriteria);
                }
                else{
                    statusContents.urlQuery.filtered[filterIndex] = filterCriteria;
                }
            }
        }
        else {
            let table_columns = ["RD_Connect_ID_Experiment", "Owner", "project", "library_strategy"];
            for (let criteria of table_columns) {
                let index = statusContents.urlQuery.filtered.findIndex(item => item.id === criteria);
                if (index !== -1) statusContents.urlQuery.filtered.splice(index, 1);
            }
            let index = statusContents.urlQuery.filtered.findIndex(item => item.id.endsWith('Time'));
            if (index !== -1) statusContents.urlQuery.filtered.splice(index, 1);
        }
        // 4.Check sorted Criteria
        if (state.sorted) {
            statusContents.urlQuery.sorted = state.sorted;
        }
        // 5.Call POST Data
        status_filter(auth.getToken(), config.api_endpoint, JSON.stringify(statusContents.urlQuery))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            statusContents.experiments = data["items"];
            statusContents.aggregates = data["_meta"]["aggregates"];
            statusContents.pagination.page = data["_meta"]["page"];
            statusContents.pagination.pages = data["_meta"]["total_pages"];
            statusContents.pagination.pageSize = data["_meta"]["page_size"];
            statusContents.pagination.totalItems = data["_meta"]["total_items"];
            statusContents.pagination.fields = statusContents.urlQuery.fields;
            statusContents.pagination.loadData = false;
            statusContents.urlQuery = {...statusContents.urlQuery};
            setStatusContents({...statusContents});            
        })
    }

    const close = event => { setMessage("");}

    if (message) {
        return (
            <Popup open={true}>
            <div>
                <div className="page-header"> <h1> Sorry!! </h1> </div>
                <div className="alert alert-warning"> {message} </div>
                <GPAP_Button_Orange startIcon={<ArrowBackIcon />}  onClick={close}> CLOSE </GPAP_Button_Orange>
            </div>
            </Popup>);
    }

    const columnsDataOwner = getOwnerTable();
    const columnsDataProject = getProjectTable();
    const columnsDataLibraryStrategy = getLibraryStrategyTable();
    const columnsDataExperiments = getExperimentItemsTable();

    return (
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> Experiments Historic Report </Typography>

            <GPAP_Button_light href = "#/admin"  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>

            <FilterCriteria 
                startDate={startDate}
                endDate={endDate}
                handleStartDate={handleStartDate}
                handleEndDate={handleEndDate}
                libraryStrategy={libraryStrategy}
                project={project}
                group={group}
                status={status}
                changeSelection={changeSelection}
                filter={filter}
            />

            <br/> <br/>

            <SmallTableViews
                columnsDataOwner={columnsDataOwner}
                getCsvOwnerData={getCsvOwnerData}
                columnsDataProject={columnsDataProject}
                getCsvProjectData={getCsvProjectData}
                columnsDataLibraryStrategy={columnsDataLibraryStrategy}
                getCsvStrategyData={getCsvStrategyData}
                statusContents={statusContents}
                loadTableData={loadTableData}
            />
            
            <Typography variant={"h6"}> Experiments in detail </Typography>
            <ReactTableServerSide
               headers={columnsDataExperiments.headers}
               columns={columnsDataExperiments.columns}
               data={columnsDataExperiments.data}
               pagination={ columnsDataExperiments.pagination }
               loadTableData={loadExperimentsTableData}
               loading={statusContents.pagination.loadData}
               height={500}
            />
            <CsvButton getCsvData={getCsvExperimentsData} />
            
        </div>
    );

}

export default ExperimentsDates;
